import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AccessoriesDetail, AccessoriesDetailFacadeService } from '@rogers/self-serve-accessories';
import { AccessoriesService } from './accessories.service';

@Injectable({
  providedIn: 'root',
})
export class AccessoriesGuard implements CanActivate {
  constructor(
    private readonly accessoriesDetailFacadeService: AccessoriesDetailFacadeService,
    private readonly accessoriesService: AccessoriesService,
    private readonly router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.accessoriesService.accessoriesPagePayload) {
      return this.router.navigate(['/overview']);
    }

    const { accountNumber, language } = this.accessoriesService.accessoriesPagePayload;
    this.accessoriesDetailFacadeService
      .loadAccessoriesDetail$(this.accessoriesService.accessoriesPagePayload)
      .pipe(take(1))
      .subscribe();
    return this.accessoriesDetailFacadeService
      .getAccessoriesDetail$(accountNumber, language)
      .pipe(map((detail: AccessoriesDetail) => !!detail));
  }
}
